module.exports = __webpack_public_path__ + "static/media/14.1e91d205.svg";